<template>
  <div class="accept-metadata-inspection-button">
    <vf-button
      :busy="isContinueProcessRequestPending"
      :variant="buttonVariants.primary"
      class="continue-process-button"
      @click="handleContinueProcessClick"
      >{{ $t('documentDetailView.continueProcess') }}</vf-button
    >
  </div>
</template>

<script src="./AcceptMetadataInspectionButton.script.ts" lang="ts"></script>
<style
  src="./AcceptMetadataInspectionButton.style.scss"
  lang="scss"
  scoped
></style>
